export default __webpack_public_path__ + "static/media/volunteer-network.7751fddb.PNG";